import { Component, input } from '@angular/core';

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.scss'],
  standalone : false
})
export class NewHeaderComponent {
  title = input<string>('');
  subtitle = input<string>('');
  constructor() { }

}
